// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Loyalty from "../../modules/Loyalty/Loyalty.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as BarControl from "../../resources/layout-and-structure/BarControl.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Math from "@rescript/runtime/lib/es6/Stdlib_Math.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as AmountTableCell from "../../modules/TableCell/AmountTableCell.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as LegacyPagination from "../../resources/navigation/LegacyPagination.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as LegacyResourceList from "../../core/LegacyResourceList.res.js";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query AnalyticsShopsPageQuery($filterBy: ShopKeyPerformanceIndicatorsQueryFilter)  {\nshopsKeyPerformanceIndicators(first: 50, filterBy: $filterBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nshop  {\n__typename  \nid  \nname  \n}\n\nticketsRevenue  {\n__typename  \nincludingTaxes  \nexcludingTaxes  \n}\n\ninvoicesRevenue  {\n__typename  \nincludingTaxes  \nexcludingTaxes  \n}\n\nglobalRevenue  {\n__typename  \nincludingTaxes  \nexcludingTaxes  \n}\n\nsalesCount  \nsalesIndex  \nshoppingCartAverage  \ntotalAmountOfTaxes  \nproductsSoldCount  \ntotalPurchaseCost  \nmargin  \nmarginRate  \nmarkupRate  \nnewCustomersCount  \nnewCustomersWithLoyaltyCount  \n}\n\n}\n\ntotalCount  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.shopsKeyPerformanceIndicators;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    shopsKeyPerformanceIndicators: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        let value$3 = value$1.ticketsRevenue;
        let value$4 = value$1.invoicesRevenue;
        let value$5 = value$1.globalRevenue;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id,
              name: value$2.name
            },
            ticketsRevenue: {
              __typename: value$3.__typename,
              includingTaxes: value$3.includingTaxes,
              excludingTaxes: value$3.excludingTaxes
            },
            invoicesRevenue: {
              __typename: value$4.__typename,
              includingTaxes: value$4.includingTaxes,
              excludingTaxes: value$4.excludingTaxes
            },
            globalRevenue: {
              __typename: value$5.__typename,
              includingTaxes: value$5.includingTaxes,
              excludingTaxes: value$5.excludingTaxes
            },
            salesCount: value$1.salesCount,
            salesIndex: value$1.salesIndex,
            shoppingCartAverage: value$1.shoppingCartAverage,
            totalAmountOfTaxes: value$1.totalAmountOfTaxes,
            productsSoldCount: value$1.productsSoldCount,
            totalPurchaseCost: value$1.totalPurchaseCost,
            margin: value$1.margin,
            marginRate: value$1.marginRate,
            markupRate: value$1.markupRate,
            newCustomersCount: value$1.newCustomersCount,
            newCustomersWithLoyaltyCount: value$1.newCustomersWithLoyaltyCount
          }
        };
      }),
      totalCount: value$1.totalCount
    }
  };
}

function serialize(value) {
  let value$1 = value.shopsKeyPerformanceIndicators;
  let value$2 = value$1.totalCount;
  let value$3 = value$1.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.newCustomersWithLoyaltyCount;
    let value$3 = value$1.newCustomersCount;
    let value$4 = value$1.markupRate;
    let value$5 = value$1.marginRate;
    let value$6 = value$1.margin;
    let value$7 = value$1.totalPurchaseCost;
    let value$8 = value$1.productsSoldCount;
    let value$9 = value$1.totalAmountOfTaxes;
    let value$10 = value$1.shoppingCartAverage;
    let value$11 = value$1.salesIndex;
    let value$12 = value$1.salesCount;
    let value$13 = value$1.globalRevenue;
    let value$14 = value$13.excludingTaxes;
    let value$15 = value$13.includingTaxes;
    let value$16 = value$13.__typename;
    let globalRevenue = {
      __typename: value$16,
      includingTaxes: value$15,
      excludingTaxes: value$14
    };
    let value$17 = value$1.invoicesRevenue;
    let value$18 = value$17.excludingTaxes;
    let value$19 = value$17.includingTaxes;
    let value$20 = value$17.__typename;
    let invoicesRevenue = {
      __typename: value$20,
      includingTaxes: value$19,
      excludingTaxes: value$18
    };
    let value$21 = value$1.ticketsRevenue;
    let value$22 = value$21.excludingTaxes;
    let value$23 = value$21.includingTaxes;
    let value$24 = value$21.__typename;
    let ticketsRevenue = {
      __typename: value$24,
      includingTaxes: value$23,
      excludingTaxes: value$22
    };
    let value$25 = value$1.shop;
    let value$26 = value$25.name;
    let value$27 = value$25.id;
    let value$28 = value$25.__typename;
    let shop = {
      __typename: value$28,
      id: value$27,
      name: value$26
    };
    let value$29 = value$1.__typename;
    let node = {
      __typename: value$29,
      shop: shop,
      ticketsRevenue: ticketsRevenue,
      invoicesRevenue: invoicesRevenue,
      globalRevenue: globalRevenue,
      salesCount: value$12,
      salesIndex: value$11,
      shoppingCartAverage: value$10,
      totalAmountOfTaxes: value$9,
      productsSoldCount: value$8,
      totalPurchaseCost: value$7,
      margin: value$6,
      marginRate: value$5,
      markupRate: value$4,
      newCustomersCount: value$3,
      newCustomersWithLoyaltyCount: value$2
    };
    let value$30 = value.__typename;
    return {
      __typename: value$30,
      node: node
    };
  });
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let shopsKeyPerformanceIndicators = {
    __typename: value$8,
    pageInfo: pageInfo,
    edges: edges,
    totalCount: value$2
  };
  return {
    shopsKeyPerformanceIndicators: shopsKeyPerformanceIndicators
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectShopKeyPerformanceIndicatorsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.startDate;
  let a$2 = inp.endDate;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    startDate: a$1 !== undefined ? a$1 : undefined,
    endDate: a$2 !== undefined ? a$2 : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectShopKeyPerformanceIndicatorsQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectShopKeyPerformanceIndicatorsQueryFilter(shopIds, startDate, endDate, param) {
  return {
    shopIds: shopIds,
    startDate: startDate,
    endDate: endDate
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let AnalyticsShopsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectShopKeyPerformanceIndicatorsQueryFilter: serializeInputObjectShopKeyPerformanceIndicatorsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectShopKeyPerformanceIndicatorsQueryFilter: makeInputObjectShopKeyPerformanceIndicatorsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let AnalyticsShopsQuery_refetchQueryDescription = include.refetchQueryDescription;

let AnalyticsShopsQuery_useLazy = include.useLazy;

let AnalyticsShopsQuery_useLazyWithVariables = include.useLazyWithVariables;

let AnalyticsShopsQuery = {
  AnalyticsShopsQuery_inner: AnalyticsShopsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectShopKeyPerformanceIndicatorsQueryFilter: serializeInputObjectShopKeyPerformanceIndicatorsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectShopKeyPerformanceIndicatorsQueryFilter: makeInputObjectShopKeyPerformanceIndicatorsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: AnalyticsShopsQuery_refetchQueryDescription,
  use: use,
  useLazy: AnalyticsShopsQuery_useLazy,
  useLazyWithVariables: AnalyticsShopsQuery_useLazyWithVariables
};

function jsonCodec(shops) {
  return JsonCodec.object2(param => [
    Stdlib_Option.map(param.shop, shop => shop.id),
    Stdlib_Option.map(param.dateRange, param => [
      param[0].getTime(),
      param[1].getTime()
    ])
  ], param => {
    let shopId = param[0];
    return {
      TAG: "Ok",
      _0: {
        shop: shops.find(shop => shop.id === shopId),
        dateRange: Stdlib_Option.flatMap(param[1], range => {
          if (range.length !== 2) {
            return;
          }
          let start = range[0];
          let end = range[1];
          return [
            new Date(start),
            new Date(end)
          ];
        })
      }
    };
  }, JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("dateRange", JsonCodec.array(JsonCodec.float))));
}

let AnalyticsShopsFilters = {
  jsonCodec: jsonCodec
};

function totalPages(rows) {
  return Stdlib_Math.Int.ceil(rows.length / 50);
}

function paginate(rows, currentPage) {
  return rows.slice((currentPage - 1 | 0) * 50 | 0, currentPage * 50 | 0);
}

function getPage(paginateAction, prevPage, totalPages) {
  switch (paginateAction) {
    case "First" :
      return 1;
    case "Prev" :
      if (prevPage !== 1) {
        return prevPage - 1 | 0;
      } else {
        return 1;
      }
    case "Next" :
      if (prevPage >= totalPages) {
        return prevPage;
      } else {
        return prevPage + 1 | 0;
      }
    case "Last" :
      return totalPages;
  }
}

function keyExtractor(param) {
  return param.shopId;
}

let AnalyticsShopsTableRow = {
  rowsPerPage: 50,
  totalPages: totalPages,
  paginate: paginate,
  getPage: getPage,
  keyExtractor: keyExtractor
};

function analyticsShopsTableRowsFromQueryResult(queryResult) {
  return queryResult.shopsKeyPerformanceIndicators.edges.map(param => {
    let node = param.node;
    return {
      shopId: node.shop.id,
      shopName: node.shop.name,
      ticketsRevenueIncludingTaxes: node.ticketsRevenue.includingTaxes,
      ticketsRevenueExcludingTaxes: node.ticketsRevenue.excludingTaxes,
      invoicesRevenueIncludingTaxes: node.invoicesRevenue.includingTaxes,
      invoicesRevenueExcludingTaxes: node.invoicesRevenue.excludingTaxes,
      globalRevenueIncludingTaxes: node.globalRevenue.includingTaxes,
      globalRevenueExcludingTaxes: node.globalRevenue.excludingTaxes,
      salesCount: node.salesCount,
      margin: node.margin,
      marginRate: node.marginRate,
      markupRate: node.markupRate,
      salesIndex: node.salesIndex,
      shoppingCartAverage: node.shoppingCartAverage,
      productsSoldCount: node.productsSoldCount,
      totalAmountOfTaxes: node.totalAmountOfTaxes,
      totalPurchaseCost: node.totalPurchaseCost,
      currency: "EUR",
      newCustomersCount: node.newCustomersCount,
      newCustomersWithLoyaltyCount: node.newCustomersWithLoyaltyCount
    };
  });
}

function analyticsShopsVariablesFilterBy(param) {
  let dateRange = param.dateRange;
  let shop = param.shop;
  return {
    shopIds: shop !== undefined ? ({
        _in: [shop.id]
      }) : undefined,
    startDate: Stdlib_Option.map(dateRange, param => Scalar.Datetime.serialize(param[0])),
    endDate: Stdlib_Option.map(dateRange, param => Scalar.Datetime.serialize(param[1]))
  };
}

function analyticsShopsQueryVariables(param) {
  return {
    filterBy: analyticsShopsVariablesFilterBy(param.filters)
  };
}

function AnalyticsShopsPage(props) {
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let match = React.useState(() => 1);
  let setCurrentPage = match[1];
  let currentPage = match[0];
  let now = new Date();
  let initialFilters_dateRange = [
    DateHelpers.startOfDay(now),
    DateHelpers.endOfDay(now)
  ];
  let initialFilters = {
    shop: activeShop,
    dateRange: initialFilters_dateRange
  };
  let initialState = LegacyResourceList.initialState(initialFilters);
  let filtersJsonCodec = jsonCodec(shops);
  let resourceListPropState = LegacyResourceList.use(initialState, filtersJsonCodec);
  let dispatch = resourceListPropState[1];
  let state = resourceListPropState[0];
  let queryAsyncResult = ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, analyticsShopsQueryVariables(state)));
  let tableColumns = [
    {
      key: "shop",
      name: I18n.t("Shop"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 160
        },
        width: {
          NAME: "pct",
          VAL: 20
        },
        margin: "small",
        sticky: true
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.data.shopName
      })
    },
    {
      key: "revenues",
      name: I18n.t("Revenue excl. VAT"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        },
        width: {
          NAME: "fr",
          VAL: 2
        },
        sticky: true
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(AmountTableCell.make, {
          value: match.globalRevenueExcludingTaxes,
          secondaryValue: match.globalRevenueIncludingTaxes
        });
      }
    },
    {
      key: "margin",
      name: I18n.t("Margin"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        },
        width: {
          NAME: "fr",
          VAL: 1.5
        }
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(TextStyle.make, {
          children: I18n.currencyFormat(undefined, match.currency, undefined, undefined, match.margin),
          weight: "semibold"
        });
      }
    },
    {
      key: "margin-markup-rates",
      name: I18n.t("Margin/Markup rt"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 100
        },
        width: {
          NAME: "fr",
          VAL: 2.5
        }
      },
      render: param => {
        let match = param.data;
        let formattedMarginRate = I18n.percentFormat(undefined, 2, 2, match.marginRate / 100);
        let formattedMarkupRate = I18n.percentFormat(undefined, 2, 2, match.markupRate / 100);
        return JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: formattedMarginRate
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: formattedMarkupRate,
              variation: "normal",
              size: "tiny"
            })
          ],
          space: "xxsmall"
        });
      }
    },
    {
      key: "cost-of-sales",
      name: I18n.t("Cost of sales"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        },
        width: {
          NAME: "fr",
          VAL: 2
        },
        margin: "small",
        alignX: "flexEnd"
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(TextStyle.make, {
          children: I18n.currencyFormat(undefined, match.currency, undefined, undefined, match.totalPurchaseCost)
        });
      }
    },
    {
      key: "avg-basket",
      name: I18n.t("Avg. basket"),
      layout: {
        margin: "small",
        alignX: "flexEnd"
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(TextStyle.make, {
          children: I18n.currencyFormat(undefined, match.currency, undefined, undefined, match.shoppingCartAverage)
        });
      }
    },
    {
      key: "sales",
      name: I18n.t("Sales"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 70
        },
        width: {
          NAME: "px",
          VAL: 120
        },
        alignX: "center"
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.data.salesCount
      })
    },
    {
      key: "sales-index",
      name: I18n.t("Sales index"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 85
        },
        width: {
          NAME: "px",
          VAL: 130
        },
        alignX: "center"
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: I18n.decimalFormat(undefined, undefined, undefined, undefined, param.data.salesIndex)
      })
    },
    {
      key: "products-sold",
      name: I18n.t("Products sold"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 80
        },
        width: {
          NAME: "px",
          VAL: 130
        },
        alignX: "center"
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.data.productsSoldCount
      })
    },
    {
      key: "new-customers",
      name: I18n.t("Customers"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 70
        },
        width: {
          NAME: "px",
          VAL: 130
        },
        alignX: "center"
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.data.newCustomersCount
      })
    },
    {
      key: "new-customers-with-loyalty",
      name: I18n.t("Customers (loyalty)"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 100
        },
        width: {
          NAME: "px",
          VAL: 130
        },
        alignX: "center"
      },
      render: param => {
        let match = param.data;
        if (Loyalty.isAddonActivated(shops, match.shopId)) {
          return JsxRuntime.jsx(TextStyle.make, {
            children: match.newCustomersWithLoyaltyCount
          });
        } else {
          return JsxRuntime.jsx(Placeholder.NA.make, {});
        }
      }
    }
  ];
  let shop = state.filters.shop;
  let loyaltyEnabled = shop !== undefined ? shop.loyaltyAddonActivated : Loyalty.isAddonActivatedInAny(shops);
  let tableColumns$1 = loyaltyEnabled ? tableColumns : tableColumns.filter(param => param.key !== "new-customers-with-loyalty");
  let filters = JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(Auth.SelectShopFilter.make, {
        value: state.filters.shop,
        onChange: shop => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: shop,
            dateRange: prev.dateRange
          })
        })
      }),
      JsxRuntime.jsx(CanarySeparator.make, {}),
      JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.dateRange,
        placeholder: I18n.t("Select a period"),
        hideResetButton: true,
        onChange: dateRange => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            dateRange: dateRange
          })
        }),
        triggerLabelDisplay: "showPreset"
      })
    ],
    space: "small"
  });
  let tableRows = AsyncResult.mapError(AsyncResult.mapOk(queryAsyncResult, analyticsShopsTableRowsFromQueryResult), param => {});
  let paginatedTableRows = AsyncResult.mapOk(tableRows, rows => paginate(rows, currentPage));
  let totalPages$1;
  if (typeof tableRows !== "object") {
    totalPages$1 = 1;
  } else if (tableRows.TAG === "Reloading") {
    let rows = tableRows._0;
    totalPages$1 = rows.TAG === "Ok" ? totalPages(rows._0) : 1;
  } else {
    let rows$1 = tableRows._0;
    totalPages$1 = rows$1.TAG === "Ok" ? totalPages(rows$1._0) : 1;
  }
  let onRequestPaginate = paginateAction => setCurrentPage(prevPage => getPage(paginateAction, prevPage, totalPages$1));
  return JsxRuntime.jsxs(Page.make, {
    children: [
      JsxRuntime.jsx(BarControl.make, {
        filters: filters
      }),
      JsxRuntime.jsx(TableView.make, {
        data: paginatedTableRows,
        columns: tableColumns$1,
        keyExtractor: keyExtractor,
        hideReloadingPlaceholder: true,
        placeholderEmptyState: EmptyState.error
      }),
      JsxRuntime.jsx(LegacyPagination.make, {
        currentPage: currentPage,
        totalPages: totalPages$1,
        onRequestPaginate: onRequestPaginate
      })
    ],
    variation: "compact",
    title: I18n.t("Performances per shop")
  });
}

let make = React.memo(AnalyticsShopsPage);

export {
  AnalyticsShopsQuery,
  AnalyticsShopsFilters,
  AnalyticsShopsTableRow,
  analyticsShopsTableRowsFromQueryResult,
  analyticsShopsVariablesFilterBy,
  analyticsShopsQueryVariables,
  make,
}
/* query Not a pure module */
